export enum ComponentType {
  purchase = 'PurchaseOrders',
  customer = 'CustomerOrders',
}
